import React, { useEffect, useState } from "react";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";
import ContributionPage from "../../entities/ContributionPage";

const Contribution = () => {
  const [contribution, setContribution] = useState([]);
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getContribution();
  }, []);
  const getContribution = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getContribution();
      console.log(result,"result----")
      if (result?.success) {
        setContribution(result?.data?.contributions);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleFringe = async (name, tax, id) => {
    setLoading(true);
    try {
      const result = await AuthService.contributionUpdate(name, tax, id);
      if (result?.success === true) {
        getContribution();
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  const handleCreateFringe = async (name, tax) => {
    setLoading(true);
    try {
      const result = await AuthService.createContribution(name, tax);
      if (result?.success === true) {
        getContribution();
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const handleDeleteFringe = async ( id) => {
    setLoading(true);
    try {
      const result = await AuthService.deleteContribution( id);
      if (result?.success === true) {
        getContribution();
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  
  return (
    <>
      <ContributionPage
        contribution={contribution}
        handleFringe={handleFringe}
        loading={loading}
        handleCreateFringe={handleCreateFringe}
        handleDeleteFringe={handleDeleteFringe}
      />
    </>
  );
};

export default Contribution;
